import { PlausibleTracker } from './trackers/plausible-tracker';
import { GtagTracker } from './trackers/gtag-tracker';
import {
	Tracker,
	TrackingEvent,
	TrackerLogger,
	TrackerHandles,
} from './tracking.events';
import { MetaPixelTracker } from './trackers/meta-pixel-tracker';
import { MatomoTracker } from './trackers/matomo-tracker';
import { TiktokPixelTracker } from './trackers/tiktok-pixel-tracker';
import { SegmentTracker } from './trackers/segment-tracker';

export class Trackers implements Tracker {
	gtag: Tracker | null = null;
	gtm: Tracker | null = null;
	matomo: Tracker | null = null;
	plausible: Tracker | null = null;
	metaPixel: Tracker | null = null;
	tikTokPixel: Tracker | null = null;
	segment: Tracker | null = null;

	constructor(args: TrackersArgs) {
		const { gtag, plausible, metaPixel, matomo, tiktokPixel, segment } =
			args;
		TrackerLogger.debug(`Trackers`, args);

		if (gtag) {
			this.gtag = new GtagTracker();
		}

		if (plausible) {
			this.plausible = new PlausibleTracker(plausible);
		}

		if (metaPixel) {
			this.metaPixel = new MetaPixelTracker(metaPixel);
		}

		// Its own slot: this used to assign `this.metaPixel`, so a tenant with
		// both pixels configured silently lost every Meta Pixel event.
		if (tiktokPixel) {
			this.tikTokPixel = new TiktokPixelTracker(tiktokPixel);
		}

		if (matomo) {
			this.matomo = new MatomoTracker(matomo);
		}

		if (segment) {
			this.segment = new SegmentTracker(segment);
		}
	}
	sendEvent(event: TrackingEvent) {
		TrackerLogger.debug(`Event:`, event);
		if (this.gtag) {
			this.gtag.sendEvent(event);
		}
		if (this.gtm) {
			this.gtm.sendEvent(event);
		}
		if (this.matomo) {
			this.matomo.sendEvent(event);
		}
		if (this.plausible) {
			this.plausible.sendEvent(event);
		}
		if (this.metaPixel) {
			this.metaPixel.sendEvent(event);
		}
		if (this.tikTokPixel) {
			this.tikTokPixel.sendEvent(event);
		}
		if (this.segment) {
			this.segment.sendEvent(event);
		}
	}
}

type TrackersArgs = TrackerHandles;
